import type { OperationResponse, Parameters } from "../../common";
import type * as Paths from "./paths";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { omitPathParameters, replacePathParameters } from "../../utils";

interface OperationMethods {
  "previewDocument"(
    parameters?: Parameters<Paths.PreviewDocument.PathParameters> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.PreviewDocument.Responses.$200>;
  "fillingPosting"(
    parameters?: Parameters<Paths.FillingPosting.PathParameters> | null,
    data?: Paths.FillingPosting.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.FillingPosting.Responses.$200>;
}

export const getAccountingPostingOperations = (client: AxiosInstance) => {
  const previewDocument: OperationMethods["previewDocument"] = (
    parameters,
    data,
    config,
  ) => {
    const url =
      "/accounting-posting/{id}/document/{accountingPostingDocument}/preview";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  const fillingPosting: OperationMethods["fillingPosting"] = (
    parameters,
    data,
    config,
  ) => {
    const url =
      "/accounting-posting/{id}/document/{accountingPostingDocument}/filling";
    return client.post(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  return {
    previewDocument,
    fillingPosting,
  };
};
